import { TFunction } from 'react-i18next';
import {
  TYPE_HMO,
  TYPE_PPO,
  TYPE_MEDICARE,
  TYPE_MEDICAID,
  TYPE_TRICARE,
  TYPE_OTHER,
  TYPE_UNKNOWN,
} from '../../../constants/index';

const universalOptions = [
  { key: TYPE_HMO, label: 'HMO' },
  { key: TYPE_PPO, label: 'PPO' },
  { key: TYPE_MEDICARE, label: 'Medicare' },
  { key: TYPE_MEDICAID, label: 'Medicaid' },
  { key: TYPE_TRICARE, label: 'Tricare' },
];

export const getInsuranceTypes = (t: TFunction<('common' | 'addInsurance')[]>) => [
  ...universalOptions,
  { key: TYPE_OTHER, label: t('addInsurance:insuranceTypes.other') },
  { key: TYPE_UNKNOWN, label: t('addInsurance:insuranceTypes.dontKnow') },
];
